/**
 * Context for Feature App with FA Services
 * @see: https://github.com/volkswagen-onehub/audi-feature-app-hello-world/blob/master/src/context.tsx
 */
import * as React from 'react';

import type {
  ContentService,
  GfaLocaleServiceV1,
  Logger,
  TrackingService,
  QueryCacheService,
} from './feature-service-types';

export interface ContextValue {
  localeService: GfaLocaleServiceV1;
  logger: Logger;
  trackingService?: TrackingService;
  contentService?: ContentService;
  queryCacheService?: QueryCacheService;
}

const FeatureServiceContext = React.createContext<ContextValue>({
  localeService: {} as GfaLocaleServiceV1,
  logger: console,
  contentService: {} as ContentService,
});

export default FeatureServiceContext;
